import React, { useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import PortalPeopleApi from "../../api/PortalPeopleApi";
import { ManagerList } from "../../models/Response/PortalPeople";
import tw from "twin.macro";
import styled from "styled-components";
import { slugify } from "utils/slugify";
import PortalApi from "api/PortalApi";
import { useParams } from "react-router-dom";
import { Project } from "models/Response/Portal";

interface CardData {
  imageSrc: string;
  title: string;
  link?: string;
  titleText?: string;
}

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-8`;
const Grid = tw.div`
  grid 
  grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5
  gap-6
  mx-4
`;

const Card = styled.a`
  ${tw`
    flex flex-col h-full w-full 
    sm:border sm:rounded-tl-4xl sm:rounded-br-5xl 
    relative focus:outline-none
    bg-primary-200 text-black
    cursor-pointer transition duration-300
    hover:bg-primary-300 hover:scale-105
  `}
`;

interface CardImageProps {
  imageSrc: string;
}
const CardImage = styled.div<CardImageProps>((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`w-full h-40 sm:h-48 bg-cover bg-center rounded sm:rounded-none sm:rounded-tl-4xl`,
]);

const TextInfo = tw.div`p-4`;
const Title = tw.h5`text-lg font-bold`;
const TitleText = tw.p`text-sm font-thin`;

const Projelerimiz: React.FC = () => {
  const { pageName, projectType } = useParams<{ pageName: string; projectType: string }>();
  const [cards, setCards] = useState<CardData[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await PortalApi.getProjects(Number(projectType));
        if (response && response.projectsList) {
          const mappedCards = response.projectsList.map((item: Project) => ({
            imageSrc: item.projectMainImage,
            title: item.projectName,
            titleText:
              Number(projectType) === 2
                ? "Devam Eden Projeler"
                : Number(projectType) === 1
                ? "Tamamlanan Projeler"
                : "",
            link: `/ProjeDetay/${slugify(item.projectName)}/${item.projectId}`,
          }));
          setCards(mappedCards);
        }
      } catch (error) {
        console.error("Projeler alınırken hata:", error);
      }
    };

    fetchData();
  }, [projectType]);

  return (
    <Layout>
      <BasicHeader
        headingLine1={Number(projectType) === 2 ? "Devam Eden" : Number(projectType) === 1 ? "Tamamlanan" : ""}
        headingLine2="Projelerimiz"
      />
      <Container>
        <Content>
          <Grid>
            {cards.map((card, index) => (
              <Card key={index} href={card.link || "#"}>
                <CardImage imageSrc={card.imageSrc} />
                <TextInfo>
                  <Title>{card.title}</Title>
                  <TitleText>{card.titleText}</TitleText>
                </TextInfo>
              </Card>
            ))}
          </Grid>
        </Content>
      </Container>
    </Layout>
  );
};

export default Projelerimiz;
